import {Navbar, NavbarBrand, Nav} from '@resurs/tron-react';

const Navigationbar = () => {
  return (
    <div>
      <Navbar fixed="top" light expand="md" className="bg-white">
        <NavbarBrand>
          <div className="logo mr-2 mt-1" />
        </NavbarBrand>
        <Nav className="ml-auto" navbar />
      </Navbar>
    </div>
  );
};

export default Navigationbar;
